<template>
    <Card title="Integration manager">
        <Table>
            <template v-slot:headers>
                <th>
                    {{ __('general.integration') }}
                </th>
                <th class="text-center">
                    Code
                </th>
                <th class="text-center">
                    Enabled
                </th>
                <th class="text-center">
                    Visible
                </th>
                <th class="text-center">
                    Active Users
                </th>
                <th class="text-center">
                    Active Stores
                </th>
                <th class="text-right">
                    {{ __('general.actions') }}
                </th>
            </template>

            <tr v-for="integration in integrations">
                <td>
                    <img v-if="integration.icon_url"
                         :src="integration.icon_url"
                         :alt="integration.code"
                         class="h-1em mr-1"
                    >
                    {{ integration.name }}
                </td>
                <td class="text-center">
                    {{ integration.code }}
                </td>
                <td class="text-center">
                    <i v-if="!integration.disabled" class="fas fa-check text-success"/>
                    <i v-else class="fas fa-times text-muted"/>
                </td>
                <td class="text-center">
                    <i v-if="integration.visible" class="fas fa-check text-success"/>
                    <i v-else class="fas fa-times text-muted"/>
                </td>
                <td class="text-center" :class="{'font-weight-bold': integration.users_active}">
                    {{ integration.users_active }}
                </td>
                <td class="text-center" :class="{'font-weight-bold': integration.stores_active}">
                    {{ integration.stores_active }}
                </td>
                <td class="text-right">
                    <Link as="button"
                          class="btn btn-xs btn-default btn-hover-primary"
                          :href="$route('integrations.admin.users', integration.code)"
                    >
                        <i class="fas fa-eye"/>
                        Users & Stores
                    </Link>
                </td>
            </tr>
        </Table>
    </Card>
</template>

<script>
import Card from "@components/Cards/Card.vue";
import Table from "@components/Table/Table.vue";
import {Link} from "@inertiajs/vue2";

export default {
    components: {Card, Table, Link},

    props: {
        integrations: Array
    }
}
</script>
